"use client";

import React from "react";
import { Facebook, Instagram, Twitter, Phone, MapPin, Clock, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors">Home</Link>
        </li>
        <li data-index={1}>
          <Link to="/ContactUsPage" className="text-muted-foreground hover:text-primary transition-colors">Contact Us</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const services = ['Dentures', 'Implants', 'Extraction', 'Sedation'];
  return <section id="footer" className="bg-background border-t border-border pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617360/img/logo_smart_choice.png" alt="Clinic Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Providing affordable, efficient, and quality dental care specializing in dentures, implants, extraction, and sedation in El Monte, California.
            </p>
            <div className="flex items-center gap-4 mt-2">
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Twitter">
                <Twitter className="size-5" />
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold text-foreground">Quick Links</h3>
            <MenuProvider menu_id="44">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold text-foreground">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={service} data-index={i}>
                  <Link to={`/${service}Page`} className="text-muted-foreground hover:text-primary transition-colors">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold text-foreground">Urgent Care</h3>
            <p className="text-muted-foreground text-sm">
              Need immediate assistance? Call us directly for priority scheduling.
            </p>
            <Link to="tel:(555)123-4567" className="text-2xl font-bold text-primary hover:text-primary/80 transition-colors flex items-center gap-2">626-268-5990</Link>
            
            <div className="space-y-3 mt-2">
              <div className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="size-4 shrink-0 mt-0.5" />
                <span>El Monte, California</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-muted-foreground">
                <Clock className="size-4 shrink-0 mt-0.5" />
                <span>Mon-Fri: 8am-5pm</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-muted-foreground">
                <Mail className="size-4 shrink-0 mt-0.5" />
                <span>smartchoicedentures@gmail.com</span>
              </div>
            </div>
          </div>

        </div>

        <Separator className="mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} smart choice dentures & implants. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-foreground transition-colors">Terms of Service</Link>
            <Link to="#" className="hover:text-foreground transition-colors">Accessibility</Link>
          </div>
        </div>
      </div>
    </section>;
}